module.exports = __webpack_public_path__ + "img/test-icon.f0624231.svg";